export default __webpack_public_path__ + "static/service_development-ddc64984aaae2a68c8d2a6c7675276ca.png";